import SpriteSymbol from "../../../../ProSpace/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../ProSpace/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-microsoft",
  "use": "icon-microsoft-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-microsoft\">\n<path d=\"M12.1039 27.4063L0 25.6543V15.9446H12.1039V27.4063Z\" fill=\"#26A6D1\" />\n<path d=\"M30 14.0571H14.0359L14.0416 2.31234L30 0.00158691V14.0571Z\" fill=\"#3DB39E\" />\n<path d=\"M30 29.9991L14.0302 27.6865L14.049 15.9464H30V29.9991Z\" fill=\"#F4B459\" />\n<path d=\"M12.1039 14.0566H0V4.34599L12.1039 2.59302V14.0566Z\" fill=\"#E2574C\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol